module.exports = __webpack_public_path__ + "img/ic_password_active.c2847514.svg";